// extracted by mini-css-extract-plugin
export default {"root":"components_root__XP57n"};